import {
  gql, useMutation
} from "@apollo/client";
import {
  useState
} from "react";

// Corrected GraphQL mutation document with explicit parameters
const ADD_CONTACT_US = gql`
  mutation AddContactUs($name: String!, $email: String!, $content: String!, $type: Int!, $platform: Int, $increment_id: String, $imgs: [String]) {
    addContactUs(input: {
      name: $name,
      email: $email,
      content: $content,
      type: $type,
      platform: $platform,
      increment_id: $increment_id,
      imgs: $imgs
    }) {
      code
      message
      content
    }
  }
`;

// Map form topic values to type numbers for the API
const topicTypeMap: Record<string, number> = {
  "product-defects": 10,
  "have-issue-placing-the-order": 11,
  "shipping-returns": 12,
  "wholesale-inquiry": 13,
  "press-inquiry": 14,
  "other": 9,
};

// Map order platform values to platform numbers
const platformMap: Record<string, number> = {
  "kingsyard": 1,
  "amazon": 2,
  "walmart": 3,
  "other": 4,
};

export interface ContactFormData {
  topic: string;
  email?: string;
  name: string;
  orderPlatform?: string;
  orderNumber?: string;
  message: string;
  files?: File[] | null;
}

export const useContactUsMutation = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  
  const [mutateFunction, {
    loading, error, data 
  }] = useMutation(ADD_CONTACT_US);
  
  const submitContactForm = async (formData: ContactFormData) => {
    try {
      // Convert files to base64 strings if present
      let imageStrings: string[] = [];
      
      if (formData.files && formData.files.length > 0) {
        imageStrings = await Promise.all(formData.files.map(async (file) => {
          return new Promise<string>((resolve) => {
            const reader = new FileReader();

            reader.onloadend = () => {
              const base64String = reader.result as string;

              resolve(base64String); // Remove the data URL prefix
            };

            reader.readAsDataURL(file);
          });
        }));
      }
      
      // Prepare variables for the mutation with explicit parameters
      let variables: any = {
        name: formData.name,
        email: formData.email || "",
        content: formData.message,
        type: topicTypeMap[formData.topic] || 0,
        imgs: imageStrings.length > 0 ? imageStrings : null
      };

      if (formData.topic === "product-defects") {
        variables = {
          ...variables,
          platform: platformMap[formData.orderPlatform || ""] || 0,
          increment_id: formData.orderNumber || "",
        };
      }
      
      const response = await mutateFunction({
        variables 
      });
      
      if (response.data?.addContactUs) {
        setIsSuccess(response.data.addContactUs.code === "200");
        setResponseMessage(response.data.addContactUs.message);
      }
      
      return response.data?.addContactUs;
    } catch (err) {
      console.error("Error submitting contact form:", err);
      throw err;
    }
  };
  
  return {
    submitContactForm,
    loading,
    error,
    data,
    isSuccess,
    responseMessage,
  };
};
